// start:ng42.barrel
import './components';
import './organisation.service';
// end:ng42.barrel

